export const PHONE = "248-820-9599";
export const TEL = "tel:+12488209599";
export const SMS = "sms:+12488209599";

export const SERVICES = [
  { key: "diag", name: "Diagnostics", price: "$85 check", desc: "Check-engine light, no-starts, strange noises. We scan, test and pinpoint the problem before anything gets replaced." },
  { key: "brakes", name: "Brakes & Suspension", price: "From $85", desc: "Pads, rotors, calipers, struts, control arms, tie rods, sway bar links and hub bearings." },
  { key: "oil", name: "Oil Changes", price: "6th one free", desc: "Done in your driveway or parking lot. Join the rewards program and your sixth oil change is on us." },
  { key: "maint", name: "Maintenance & Repairs", price: "$85 / hr", desc: "Tune-ups, alternators, starters, radiators, CV axles and heater core flushes." },
  { key: "swap", name: "Engine & Transmission Swaps", price: "Written quote", desc: "Full engine and transmission swaps, quoted in writing for your exact vehicle." },
  { key: "more", name: "& More", price: "Just ask", desc: "Don't see your repair? Call or text and we'll tell you straight if we can handle it." },
];

export const LABOR = [
  { name: "Diagnostic check", price: 85, cat: "Diagnostics" },
  { name: "Brake pads (per axle)", price: 127.5, cat: "Brakes" },
  { name: "Rotors (per axle)", price: 170, cat: "Brakes" },
  { name: "Alternator", price: 170, cat: "Electrical" },
  { name: "Tune-up", price: 170, cat: "Engine" },
  { name: "Control arm (each)", price: 170, cat: "Suspension" },
  { name: "Starter", price: 170, cat: "Electrical" },
  { name: "Brake caliper (each)", price: 127.5, cat: "Brakes" },
  { name: "Radiator", price: 255, cat: "Cooling" },
  { name: "Outer tie rod (each)", price: 85, cat: "Suspension" },
  { name: "CV axle (each)", price: 170, cat: "Suspension" },
  { name: "Strut (each)", price: 170, cat: "Suspension" },
  { name: "Sway bar link (each)", price: 85, cat: "Suspension" },
  { name: "Bolt-on hub bearing (each)", price: 170, cat: "Suspension" },
  { name: "Heater core flush", price: 127.5, cat: "Cooling" },
];

export const LABOR_CATS = ["All", "Diagnostics", "Brakes", "Suspension", "Electrical", "Engine", "Cooling"];

export const BOOKING_SERVICES = ["Diagnostics", "Oil Change", "Brakes & Suspension", "Maintenance & Repairs", "Engine / Transmission Swap", "Something else"];

export const TIME_WINDOWS = [
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "evening", label: "Evening" },
  { value: "flexible", label: "Any time" },
];

export const money = (n) => `$${Number(n).toFixed(Number(n) % 1 ? 2 : 0)}`;
export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
